/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IScheduleListMethods,
  ScheduleListService,
  ICreateScheduleMethods,
  CreateScheduleService,
  IUpdateScheduleMethods,
  UpdateScheduleService,
  IDeleteScheduleMethods,
  DeleteScheduleService,
  IPauseScheduleMethods,
  PauseScheduleService,
} from "./components";

export type SchedulePageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IScheduleListMethods &
  ICreateScheduleMethods &
  IUpdateScheduleMethods &
  IDeleteScheduleMethods &
  IPauseScheduleMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new ScheduleListService(),
    new CreateScheduleService(),
    new UpdateScheduleService(),
    new DeleteScheduleService(),
    new PauseScheduleService(),
  ];
};

export const getAgent = () => {
  return createAgent<SchedulePageAgent>({
    plugins: getPlugins(),
  });
};
